import { FeatureInfo } from '@sparky/framework';

export const checkIsFeatureEnabled = (featureList: FeatureInfo[] = [], featureKey = '') => {
	return featureList.some((feature) => feature?.name === featureKey && feature.toggle === 1);
};
